const generateId = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

class SessionTrackerClass {
  constructor() {
    // генерится один раз за жизнь страницы (аналог UUID.randomUUID())
    this.sessionId = generateId();
    // монотонные часы — аналог SystemClock.elapsedRealtime()
    this.sessionStartTime = performance.now();
  }

  getSessionDurationMs() {
    return Math.round(performance.now() - this.sessionStartTime);
  }
}

export const SessionTracker = new SessionTrackerClass();